export const saveContacts = (contacts: string[]) => {
    const storage = {
        contacts: contacts,
    };
    localStorage.setItem('escalation-info-contacts', JSON.stringify(storage || []));
};

export const retrieveContacts = (): { contacts: string[] } => {
    const storage = localStorage.getItem('escalation-info-contacts') || '';
    if (!storage) return { contacts: [] };
    try {
        return JSON.parse(storage);
    } catch {
        return { contacts: [] };
    }
};
